const popupCookie = document.getElementById("popup-cookie");

const closePopupCookie = document.getElementsByClassName("popup-cookie__button")[0];

closePopupCookie.onclick = function() {
  popupCookie.style.display = "none";
  localStorage.setItem('popupCookieShown', 'true')
}
